import { createGlobalStyle } from 'styled-components';

export const GlobalStyles = createGlobalStyle`
  body {
    font-size: 13px;
    font-family: Helvetica, Arial, Sans-serif;
  }

  /* HEADINGS */

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin-top: 0;
    margin-bottom: 0.5em;

    * {
      font-style: normal !important;
    }

    small {
      display: inline-block;
      font-size: 0.7em;
      color: #161b7a !important;
      font-weight: normal;
    }
  }

  h1 {
    font-size: 2.2em;
    color: #333;
  }

  h2 {
    font-size: 1.8em;
  }

  h3 {
    font-size: 1.6em;
  }

  h4 {
    font-size: 1.4em;
  }

  h5 {
    font-size: 1em;
  }

  h6 {
    font-size: 0.88em;
    text-transform: uppercase;
    color: #888;
  }

  h4 {
    .right {
      float: right;
    }
  }

  /* PARAGRAPH, LISTS */
  p {
    margin-top: 0;
    line-height: 1.4em;
  }

  ul,
  ol {
    margin-top: 0;
    padding-left: 1.2em;

    li {
      margin-bottom: 0.25em;
    }
  }

  ul {
    list-style-type: disc;

    ul {
      margin: 0.2em 0;
    }
  }

  ol {
    padding-left: 1.8em;
  }

  ul,
  ol {
    &.simple {
      padding: 0;
      list-style: none;

      .simple {
        padding-left: 1em;
      }
    }
  }

  /* INLINE ELEMENTS */
  em {
    color: #444;
  }

  abbr[title] {
    cursor: help;
    text-transform: uppercase;
    border-color: #999;
    color: #444;
    font-size: 0.92em;
    letter-spacing: 0.02em;
  }

  a,
  a:hover {
    color: #161b7a;

    i {
      text-decoration: none !important;
    }
  }


  body {
    overflow-x: hidden;
  }



/* UI */
  section header {
    padding: 0;
  }

  nav,
  div[role=navigation] {
    margin: 10px 0;

    a, span.not-clickable {
      display: inline-block;
      padding: 1em 10px;
      text-decoration: none;
    }
  }

  table {
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;

    thead tr th {
      text-align: center;
    }
  }

  a[href="#emailAddressEdit"] {
    &:before,
    &:after {
      display: none;
      content: '';
    }
  }

  /* @media #{$media-mobile} {
  @import './mobile/ui';
  }
  @media #{$media-touch} {
  @import './touch/ui';
  }
  @media #{$media-touch} {
  @import './tablet/ui';
  } */
  @media only screen and (min-width: 1025px) {
    a[href="#storesListC"] {
      display: none;
    }
  }


/* Base */
  html,
  body {
    min-height: 100%;
    text-rendering: optimizeLegibility;
  }

  body {
    background: #fff;
    overflow-x: hidden;
  }

  @media only screen and (max-width: 1024px) {
    body {
      font-size: 14px;
      background: #f5f5f5;
    }
  }
  @media only screen and (max-width: 599px) {
    body {
      border-top: 0;
    }

    label[for*="password"],
    label[for*="Password"] {
      display: block;
    }
  }
  /* @media #{$media-touch} {
  @import './tablet/base';
  }
  @media #{$media-desktop} {
  @import './desktop/base';
  }
  @media #{$media-wide} {
  @import './wide/base';
  } */
`;
